import { Module } from 'vuex';

export interface Policy {
  id: number | null,
  policy_name: string | null,
  categories: string[]
  
}
const defaultState: Policy = {
  id: null,
  policy_name: null,
  categories: []
};

const policyStore: Module<Policy, {}> = {
  state: defaultState,
  mutations: {
    savePolicy(state, policy: { id: number; policy_name: string; categories: string[]; }) {
      state.id = policy.id;
      state.policy_name = policy.policy_name;
      state.categories = policy.categories;
    }
  },
  actions: {
    savePolicy({ commit }, policy: { id: number; policy_name: string; categories: string[]; }) {
      // setTimeout(() => {
        commit('savePolicy', policy);
      // }, 50);
    }
  }
};

export default policyStore;
